export const courseData = [
  {
    id: 'folder1',
    title: '📁 Partiamo da qui',
    subfolders: [
      {
        id: 'sub1',
        title: 'Lezioni Base',
        lessons: [
          {
            id: '1',
            title: 'Trova i contatti',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1161364547'
          },
          {
            id: '3',
            title: 'Mapsscraper',
            type: 'link',
            linkUrl: 'https://mapsscraper.net/',
            linkText: '🔗 Vai a Mapsscraper'
          },
          {
            id: '5',
            title: 'Contatti e Google Drive',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1161364352'
          },
          {
            id: '6',
            title: 'Crea un nuovo numero: ESim',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1128799248'
          },
          {
            id: '7',
            title: 'Offerta Iliad',
            type: 'link',
            linkUrl: 'https://www.iliad.it/offerta-iliad-voce-499.html',
            linkText: '🔗 Vai all\'offerta Iliad'
          }
        ]
      }
    ]
  },
  {
    id: 'folder2',
    title: '📚 Le basi',
    subfolders: [
      {
        id: 'sub2',
        title: 'Fondamenti',
        lessons: [
          {
            id: 'c2_new_v1',
            title: 'Costanza Cold Call',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1165504146'
          },
          {
            id: 'c2_new_v2',
            title: 'Tecniche di chiamata a freddo',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1165597100'
          },
          {
            id: '10',
            title: 'Processo continuo',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1161380998'
          },
          {
            id: 'avoid_no_show',
            title: 'Evita che il prospect non si presenti',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1228497659'
          },
          {
            id: 'cold_call_examples',
            title: 'Esempi di chiamate a freddo',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1229595419'
          },
          {
            id: '11',
            title: 'Trascrizione automatica delle chiamate con L\'IA',
            type: 'video',
            videoUrl: 'https://vimeo.com/video/1224870422'
          },
          {
            id: '12',
            title: 'Vai alla trascrizione con l\'IA',
            type: 'link',
            linkUrl: 'https://audio.wawave.org/',
            linkText: '🔗 Vai al sito web'
          },
          {
            id: '12_upload_transcription',
            title: 'Carica una trascrizione',
            type: 'link',
            linkUrl: 'https://form.getformly.com/f/4eSrFR',
            linkText: 'Carica una trascrizione'
          },
          {
            id: '13',
            title: 'Il Telefono: l\'Arma più Potente',
            type: 'link',
            linkUrl: 'https://mega.nz/file/gNwAUY5A#LwBy9bLgAZZX_CZnE2tINgcU7ocb28_qzH7Noqrfexo',
            linkText: '🔗 Scarica la risorsa'
          },
          {
            id: 'c2_v2',
            title: 'Padroneggiare le Cold Call Allenandosi con l\'IA',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1162347918'
          },
          {
            id: 'c2_p3',
            title: 'Training con Gemini Live',
            type: 'link',
            linkUrl: 'https://trainingcoldcall.dynamic-web.space/',
            linkText: '🔗 Training con Gemini Live'
          }
        ]
      }
    ]
  },
  {
    id: 'folder3',
    title: '🎯 Entriamo nel pratico',
    subfolders: [
      {
        id: 'sub3',
        title: '📋 Materiali Pratici',
        lessons: [
          {
            id: '15b',
            title: 'Come usare l\'app per lo script delle chiamate',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1152045354'
          },
          {
            id: 'appointment_setter_hub_label',
            title: 'Ecco le risorse per fare chiamate e outreach per fissare appuntamenti',
            type: 'text'
          },
          {
            id: 'appointment_setter_hub',
            title: 'Appointment Setter Hub',
            type: 'link',
            linkUrl: 'https://appointmentsetterhub.dynamic-web.space/',
            linkText: '🔗 Vai ad Appointment Setter Hub'
          },
          {
            id: '26',
            title: 'Controlla Disponibilità: TidyCal',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1161364520'
          },
          {
            id: '27',
            title: 'Link TidyCal',
            type: 'link',
            linkUrl: 'https://tidycal.com/promemoria-appuntamento/consulenza-gratuita',
            linkText: '🔗 Vai a TidyCal'
          },
          {
            id: '29',
            title: 'Settare Account WhatsApp',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1136038462'
          },
          {
            id: '32',
            title: 'SMS MULTIPLI',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1161364487'
          },
          {
            id: '33',
            title: 'App SMS',
            type: 'link',
            linkUrl: 'https://play.google.com/store/search?q=MULTISMS&c=apps&hl=it&pli=1',
            linkText: '🔗 Vai al Play Store'
          },
          {
            id: '34_template_video',
            title: '📬 Template Mail,SMS e WhatsApp',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1174313378'
          },
          {
            id: '34_whatsapp_sender',
            title: 'Invia messaggi WhatsApp Gratis a persone non salvate nella tua rubrica',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1192861829',
            linkUrl: 'https://whatsapp-api-sender.dynamic-web.space/',
            linkText: '🔗 Vai al Software WhatsApp API Sender'
          },
          {
            id: '35_template',
            title: 'Template SMS e Mail',
            type: 'link',
            linkUrl: 'https://templatemail.dynamic-web.space',
            linkText: '🔗 Vai al Template'
          },
          {
            id: '36_finali',
            title: 'Istruzioni Finali',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1161364427'
          }
        ]
      }
    ]
  },
  {
    id: 'folder4',
    title: '💰 Pagamento commissioni',
    subfolders: [
      {
        id: 'sub7',
        title: 'Gestione Pagamenti',
        lessons: [
          {
            id: 'c4_new_l1',
            title: 'Piano Compensi',
            type: 'link',
            linkUrl: 'https://mega.nz/file/RcQHiA6a#eMMOq16mHDvNa7uA6JlxJAH3B6yASzpkBPdwdcBA1sI',
            linkText: '🔗 Piano Compensi'
          },
          {
            id: '36',
            title: 'Metriche Outreach e Commissioni',
            type: 'video',
            videoUrl: 'https://player.vimeo.com/video/1132442736'
          },
          {
            id: '36b',
            title: 'Vai ad Outreach Numbers',
            type: 'link',
            linkUrl: 'https://outreachnumbers.dynamic-web.space/',
            linkText: '🔗 Vai ad Outreach Numbers'
          },
          {
            id: '36c',
            title: 'Vai a Pay4Referral',
            type: 'link',
            linkUrl: 'https://pay4referral.dynamic-web.space/',
            linkText: '🔗 Vai a Pay4Referral'
          },
          {
            id: '37',
            title: 'Come compilare una Prestazione Occasionale',
            type: 'video',
            videoUrl: 'https://www.youtube.com/embed/Z1xtF7KBxLI'
          },
          {
            id: '35e',
            title: 'Compila il form per la ricevuta d\'acconto',
            type: 'link',
            linkUrl: 'https://getformly.app/dWJcuq',
            linkText: '🔗 Vai al form'
          }
        ]
      }
    ]
  }
];